/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/
const style = `* {
  box-sizing: border-box;
}

*,
:host {
  box-sizing: border-box;
  font-size: 1rem;
  font-family: inherit;
}

:host button,
:host input,
:host optgroup,
:host select,
:host textarea {
  font-family: inherit;
}

:host {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  flex-grow: 1;
}
:host .labels {
  display: inline-block;
  vertical-align: middle;
  width: 100%;
  -webkit-user-select: none;
     -moz-user-select: none;
      -ms-user-select: none;
          user-select: none;
}
:host .labels .headline {
  display: inline-flex;
  margin-right: 3.4285714286rem;
  color: #50585C;
  color: var(--davinci-color-text-light, #50585C);
  cursor: pointer;
  white-space: nowrap;
  vertical-align: middle;
  margin-bottom: 0.5714285714rem;
  border-bottom: 0.1428571429rem solid rgba(255, 255, 255, 0);
}
:host .labels .headline davinci-icon {
  height: 1.7142857143rem;
  width: 1.7142857143rem;
  fill: #50585C;
  fill: var(--davinci-color-text-light, #50585C);
}
:host .labels .headline .label {
  line-height: 1.7142857143rem;
}
:host .labels .headline .custom-icon + .label {
  margin-left: 0.5714285714rem;
}
:host .labels .headline:hover {
  color: #009DF4;
  color: var(--davinci-color-primary-light, #009DF4);
}
:host .labels .headline:hover davinci-icon {
  fill: #009DF4;
  fill: var(--davinci-color-primary-light, #009DF4);
}
:host .labels .headline:focus {
  color: #009DF4;
  color: var(--davinci-color-primary-light, #009DF4);
  outline: 0.0714285714rem solid var(--davinci-color-primary,#007CC1);
  outline-offset: 0.1428571429rem;
}
:host .labels .headline:focus davinci-icon {
  fill: #009DF4;
  fill: var(--davinci-color-primary-light, #009DF4);
}
:host .labels .headline[selected] {
  outline: none;
  border-bottom: 0.1428571429rem solid var(--davinci-color-primary,#007CC1);
  color: var(--davinci-color-primary,#007CC1);
  margin-bottom: 0;
  padding-bottom: 0.5714285714rem;
}
:host .labels .headline[selected] davinci-icon {
  fill: #007CC1;
  fill: var(--davinci-color-primary, #007CC1);
}
:host .headline[disabled] {
  pointer-events: none;
  color: #B1B8BC;
  color: var(--davinci-color-text-disabled, #B1B8BC);
}
:host .headline[disabled] davinci-icon {
  fill: #B1B8BC;
  fill: var(--davinci-color-text-disabled, #B1B8BC);
}
:host .tabs {
  height: 100%;
}

:host([type=modern]) .labels .headline .label:empty {
  display: none;
}

:host([type=classic]) .labels .headline {
  display: inline-flex;
  align-items: center;
  margin: 0 0;
  background-color: #C5CACC;
  background-color: var(--davinci-color-outline-light, #C5CACC);
  color: #2C3133;
  color: var(--davinci-color-text-on-background-3, #2C3133);
  line-height: 1.7142857143rem;
  text-align: center;
  cursor: pointer;
  white-space: nowrap;
  vertical-align: middle;
  padding-bottom: 0;
  border: none;
}
:host([type=classic]) .labels .headline .label {
  line-height: 2.5714285714rem;
  margin: 0 1.1428571429rem;
}
:host([type=classic]) .labels .headline .label + .close {
  margin-right: 0.8571428571rem;
}
:host([type=classic]) .labels .headline .custom-icon {
  fill: #2C3133;
  fill: var(--davinci-color-text-on-background-3, #2C3133);
  margin-left: 1.1428571429rem;
  height: 2.5714285714rem;
}
:host([type=classic]) .labels .headline .custom-icon + .label {
  margin-left: 0.5714285714rem;
}
:host([type=classic]) .labels .headline .custom-icon + .label:empty {
  margin-left: 1.1428571429rem;
  margin-right: 0;
}
:host([type=classic]) .labels .headline .close {
  height: 1.2857142857rem;
  width: 1.2857142857rem;
  fill: #737F85;
  fill: var(--davinci-color-text-lighter, #737F85);
}
:host([type=classic]) .labels .headline .close:hover {
  background-color: #C5CACC;
  background-color: var(--davinci-color-outline-light, #C5CACC);
}
:host([type=classic]) .labels .headline + .headline {
  margin-left: -0.2142857143rem;
}
:host([type=classic]) .labels .headline:hover {
  background-color: #EEEFF0;
  background-color: var(--davinci-color-background-3, #EEEFF0);
}
:host([type=classic]) .labels .headline:focus {
  background-color: #C5CACC;
  background-color: var(--davinci-color-outline-light, #C5CACC);
  outline-offset: 0;
}
:host([type=classic]) .labels .headline:focus .label {
  color: #50585C;
  color: var(--davinci-color-text-light, #50585C);
}
:host([type=classic]) .labels .headline[selected] {
  background-color: #FFFFFF;
  background-color: var(--davinci-color-background, #FFFFFF);
}
:host([type=classic]) .labels .headline[disabled] {
  pointer-events: none;
  background-color: #C5CACC;
  background-color: var(--davinci-color-outline-light, #C5CACC);
  color: #B1B8BC;
  color: var(--davinci-color-text-disabled, #B1B8BC);
  fill: #B1B8BC;
  fill: var(--davinci-color-text-disabled, #B1B8BC);
}
:host([type=classic]) .labels .headline[disabled] .custom-icon {
  fill: #B1B8BC;
  fill: var(--davinci-color-text-disabled, #B1B8BC);
}
:host([type=classic]) .labels .headline[disabled] .close {
  fill: #B1B8BC;
  fill: var(--davinci-color-text-disabled, #B1B8BC);
}

:host([hidden]) {
  display: none;
}`;
export { style };
